import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/retina/welcome2.png")